import {
  FETCH_PRODUCT_REVIEWS_LIST,
  FETCH_PRODUCT_SUMMARY_REVIEWS,
  GET_CANCELLATION_RULES,
  SET_REQUEST,
  SET_RESERVE,
  VIOLATION_REPORT,
} from './types'
/* eslint-disable camelcase */
import { AxiosError, AxiosResponse } from 'axios'
import { HouseCardItemProps } from '../reducer/homeReducer'
import {
  EditReserveProforma,
  IPictures,
  IProforma,
  IReserve,
  PicturesProps,
  ProductItemProps,
  ProformaProps,
  ReportType,
  WeatherItemProps,
} from '../types'

import { MainAction } from './models'
import {
  FETCH_PRODUCT,
  FETCH_PRODUCT_PICTURES,
  FETCH_PROFORMA,
  FETCH_REVIEWS,
  FETCH_SIMILAR,
  FETCH_WEATHER,
} from './types'
import { getCookie, getOSName } from '../../../helpers/props'
import { toast } from 'react-toastify'
import heap from '@/helpers/heap'
import { cpos } from '@/components/app/hooks/useInitializations'
import { digitsFaToEn } from '@persian-tools/persian-tools'

// product screen actions
export const fetchProduct: MainAction<
  [
    {
      id: string
      searchId?: string
      from?: string
      fromId?: string
      order_tracking?: number
    },
  ]
> =
  ({ id, searchId, from, fromId, order_tracking }) =>
  async (dispatch, getState, { Api }) => {
    const api = new Api({
      dispatch,
      getState,
    })
    const queryParams: {
      order_tracking?: number
      new: number
      search_id?: string
      from?: string
      fromId?: string
    } = {
      new: 1,
    }

    if (searchId) {
      queryParams.search_id = searchId
    }
    if (fromId) {
      queryParams.fromId = fromId
    }
    if (from) {
      queryParams.from = from
    }
    if (order_tracking) {
      queryParams.order_tracking = 1
    }
    try {
      dispatch({
        type: FETCH_PRODUCT,
        data: {},
        loading: true,
        status: null,
      })
      const res: AxiosResponse<{ data: ProductItemProps }> = await api.get(
        `/house/${id}`,
        queryParams,
      )
      dispatch({
        type: FETCH_PRODUCT,
        data: res?.data?.data,
        loading: false,
        status: res?.status,
      })

      // Handle Res
    } catch (err) {
      dispatch({
        type: FETCH_PRODUCT,
        data: {},
        loading: false,
        status: (err as AxiosError)?.response?.status,
      })
      // Handle Err
    }
  }

// pictures
export const fetchPictures: MainAction<[IPictures]> =
  ({ id }: IPictures) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    try {
      dispatch({
        type: FETCH_PRODUCT_PICTURES,
        data: null,
        loading: true,
      })

      const res: AxiosResponse<{ data: { data: PicturesProps } }> =
        await api.get(`house/${id}/photos`)

      dispatch({
        type: FETCH_PRODUCT_PICTURES,
        data: res?.data.data,
        loading: false,
      })

      // Handle Res
    } catch (err) {
      dispatch({
        type: FETCH_PRODUCT_PICTURES,
        data: [],
        loading: false,
      })
      // Handle Err
    }
  }
// request to visit house
export const requestToVisitHouse: MainAction<[number, any]> =
  (house_id: number, callback) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    dispatch({
      type: SET_REQUEST,
      data: null,
      loading: true,
    })

    try {
      const res: AxiosResponse = await api.post(`/visit-request`, {
        house_id,
      })
      if (res.data) {
        callback({ error: null })
        dispatch({
          type: SET_REQUEST,
          data: true,
          loading: false,
        })
      }

      // Handle Res
    } catch (err) {
      dispatch({
        type: SET_REQUEST,
        data: null,
        loading: false,
      })
      if ((err as AxiosError).response?.status === 422) {
        callback({
          error: true,
          message: (err as AxiosError).response?.data?.meta?.messages
            .house_id[0],
        })
      } else {
        callback({
          error: true,
          message: 'مشکلی پیش آمده لطفا بعدا تلاش کنید',
        })
      }
      // Handle Err
    }
  }
// similar houses:
export const fetchSimilar: MainAction<[string | string[]]> =
  (id: string | string[]) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    const {
      similarHouses: { list },
    } = getState()
    try {
      dispatch({
        type: FETCH_SIMILAR,
        list,
        loading: true,
      })
      const isFaAndEnDigits = /^[0-9\u06F0-\u06F9]+$/.test(id as string)

      if (isFaAndEnDigits) {
        id = digitsFaToEn(id as string)
      }
      const res: AxiosResponse<{ data: { records: HouseCardItemProps[] } }> =
        await api.get(`/house/${id}/similar`)

      dispatch({
        type: FETCH_SIMILAR,
        list: res?.data?.data?.records,
        loading: false,
      })

      // Handle Res
    } catch (err) {
      dispatch({
        type: FETCH_SIMILAR,
        list,
        loading: false,
      })
      // Handle Err
    }
  }
// page: number
export const fetchReviews: MainAction<[string, boolean?]> =
  (id: string, isReset = false) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    const page = getState().reviews.page
    dispatch({
      type: FETCH_REVIEWS,
      payload: getState().reviews.list,
      loading: true,
      page: 0,
      suggest: {},
      hasMore: getState().reviews.hasMore,
    })

    try {
      const res = await api.get(
        `/house/${id}/reviews?page=${isReset ? 1 : page}`,
      )
      if (isReset) {
        dispatch({
          type: FETCH_REVIEWS,
          payload: res.data?.data?.records,
          count: res.data?.data?.pagination?.total,
          loading: false,
          page: 2,
          hasMore: res.data?.data?.records?.length !== 0,
          suggest: res.data?.data?.suggest,
        })
      } else {
        dispatch({
          type: FETCH_REVIEWS,
          payload: [
            ...getState().reviews.list,
            ...(res.data?.data?.records || []),
          ],
          count: res.data?.data?.pagination?.total,
          loading: false,
          page: Number(page) + 1,
          hasMore: res.data?.data?.records?.length !== 0,
          suggest: res.data?.data?.suggest,
        })
      }
    } catch (err) {
      // Handle err
      dispatch({
        type: FETCH_REVIEWS,
        payload: getState().reviews.list,
        loading: false,
        hasMore: getState().reviews.hasMore,
        page,
      })
    }
  }
export const fetchProductSummaryReviews: MainAction<[number]> =
  (id: number) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    try {
      dispatch({
        type: FETCH_PRODUCT_SUMMARY_REVIEWS,
        data: null,
        loading: true,
      })

      // Handle Res
      const res: AxiosResponse = await api.get(`/house/${id}/reviews`, {
        page: 1,
      })
      dispatch({
        type: FETCH_PRODUCT_SUMMARY_REVIEWS,
        data: {
          reviews: res?.data?.data?.records ?? [],
          total: res?.data?.data?.pagination?.total,
          count: res?.data?.data?.suggest?.count,
        },
        loading: false,
      })
    } catch (err) {
      // Handle Err
      dispatch({
        type: FETCH_PRODUCT_SUMMARY_REVIEWS,
        data: null,
        loading: false,
      })
    }
  }
export const fetchProductReviews: MainAction<[number, number]> =
  (id: number, page = 1) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    try {
      dispatch({
        type: FETCH_PRODUCT_REVIEWS_LIST,
        data: {
          reviews:
            getState()?.productReducer?.data?.productReviewsList?.data?.reviews,
          total:
            getState()?.productReducer?.data?.productReviewsList?.data?.total,
        },
        loading: true,
      })

      // Handle Res
      const res: AxiosResponse = await api.get(`/house/${id}/reviews`, {
        per_page: 6,
        page,
      })
      dispatch({
        type: FETCH_PRODUCT_REVIEWS_LIST,
        data: {
          reviews: [
            ...(+page === 1
              ? []
              : getState()?.productReducer?.data?.productReviewsList?.data
                  ?.reviews || []),
            ...(res?.data?.data?.records ?? []),
          ],
          total: res?.data?.data?.pagination?.total,
        },
        loading: false,
      })
    } catch (err) {
      // Handle Err
      dispatch({
        type: FETCH_PRODUCT_REVIEWS_LIST,
        data: null,
        loading: false,
      })
    }
  }

// weather
export const fetchWeather: MainAction =
  () =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    const city = getState().product.data.location?.city

    try {
      dispatch({
        type: FETCH_WEATHER,
        data: [],
        loading: true,
      })

      const res: AxiosResponse<{ data: { records: WeatherItemProps[] } }> =
        await api.get(`/weather/forecast/city?name=${city}&days_count=4`, {
          city,
        })

      dispatch({
        type: FETCH_WEATHER,
        data: res?.data,
        loading: false,
      })

      // Handle Res
    } catch (err) {
      dispatch({
        type: FETCH_WEATHER,
        data: [],
        loading: false,
      })
      // Handle Err
    }
  }

// proforma
export const fetchProforma: MainAction<[EditReserveProforma]> =
  ({ checkin, checkout, guestsCount, houseId }: EditReserveProforma) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    try {
      dispatch({
        type: FETCH_PROFORMA,
        data: getState().proforma.data,
        loading: true,
      })

      const res: AxiosResponse<{ data: { data: ProformaProps } }> =
        await api.get('/reserve/proforma', {
          checkin,
          checkout,
          guests_count: guestsCount,
          house_id: houseId,
          order_id: 'test',
          sort: 'is_descending[rate]=1',
          v2: true,
        })

      dispatch({
        type: FETCH_PROFORMA,
        data: res?.data.data,
        loading: false,
      })

      // Handle Res
    } catch (err) {
      dispatch({
        type: FETCH_PROFORMA,
        data: [],
        loading: false,
      })
      // Handle Err
    }
  }
export const setReserve: MainAction<[IReserve]> =
  ({ checkin, checkout, guests_count, house_id, os }: IReserve) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    try {
      dispatch({
        type: SET_RESERVE,
        data: null,
        loading: true,
      })

      const res: AxiosResponse<{ data: { data: any } }> = await api.post(
        'reserve',
        {
          os,
          checkin,
          checkout,
          house_id,
          guests_count,
          order_id: 'test',
        },
      )

      dispatch({
        type: SET_RESERVE,
        data: res?.data.data,
        loading: false,
      })

      // Handle Res
    } catch (err) {
      dispatch({
        type: SET_RESERVE,
        data: [],
        loading: false,
      })
      // Handle Err
    }
  }

export interface ReserveParams {
  checkin: string
  checkout: string
  guests_count: string | number
  house_id: any
  order_id: string
  sort?: string
  city_name: string
  is_safe?: string
  from_plp_ad?: string
}

export const reserveHouse: MainAction<
  [ReserveParams, any, any, any?, boolean?]
> =
  (data, loadingCallback, handleReserveWithLogin, callbackHandler, ismidterm) =>
  async (dispatch, getState, { Api, ctx }) => {
    let cpo = ''
    cpos.forEach(item => {
      const cookie = getCookie(item)
      if (cookie) {
        cpo = `${item}::${cookie}`
      }
    })

    const api = new Api({
      dispatch,
      getState,
      ctx,
      ...(cpo && { headers: { cpo } }),
    })

    const getPlatform = () => {
      if (typeof window !== 'undefined') {
        if (document.referrer?.includes('android-app://')) {
          return 'app'
        } else if (window.matchMedia('(display-mode: standalone)').matches) {
          return 'pwa'
        } else {
          return 'web'
        }
      }
    }
    const eventData = {
      house_id: data?.house_id,
      city_name: data?.city_name,
      price_guarantee: getState()?.product?.data?.price_guarantee,
      platform: getPlatform(),
      ismidterm,
    }

    loadingCallback(true)
    try {
      const utm_source = sessionStorage.getItem('utm_source')
      const utm_campaign = sessionStorage.getItem('utm_campaign')
      const utm_medium = sessionStorage.getItem('utm_medium')

      const utmParams = {
        ...(utm_source && { utm_source }),
        ...(utm_campaign && { utm_campaign }),
        ...(utm_medium && { utm_medium }),
      }
      const res = await api.post('/reserve', {
        ...data,
        ...utmParams,
        os: getOSName(),
      })

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'reserve_request',
        user_id: getState()?.bootstrapData?.data?.user_info?.uid,
        phone_number: getState()?.bootstrapData?.data?.user_info?.mobile,
        house_id: data?.house_id,
        request_date: new Date().toISOString(), // تاریخ و زمان ثبت درخواست
        checkin_date: data?.checkin,
        checkout_date: data?.checkout,
        nights: getState()?.proforma?.data?.days?.[0]?.count,
        guests: data?.guests_count,
        city: data?.city_name,
        province: getState()?.product?.data?.location?.province,
        total_price:
          getState()?.proforma?.data?.total_payable_amount?.final_price,
        reserve_type: res?.data?.data?.is_instant ? 'instant' : 'pending', // "pending" یا "instant"
      })

      toast.success('درخواست رزرو با موفقیت ثبت شد', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })

      heap.track('reserve_request', eventData)

      setTimeout(() => {
        loadingCallback(false)
        callbackHandler(res)
        // if (res?.data?.data?.is_instant && callbackHandler) {
        //   callbackHandler(res)
        // } else {
        //   window.location.href = `/trips`
        // }
      }, 3000)
    } catch (err) {
      // Handle Err
      if ((err as AxiosError).response) {
        if ((err as AxiosError).response?.status === 401) {
          handleReserveWithLogin()
        }

        const errMessage = (err as AxiosError).response?.data.meta.messages
          ? (err as AxiosError).response?.data.meta.messages[0]
          : ''
        if (errMessage) {
          toast.error(errMessage, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        }
      }
      setTimeout(() => {
        loadingCallback(false)
      }, 1000)
    }
  }

export const violationReport: MainAction<[ReportType, any]> =
  ({ id, description }: ReportType, callback: any) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    try {
      const res: AxiosResponse = await api.post(`/house/${id}/feedback`, {
        description,
      })
      dispatch({
        type: VIOLATION_REPORT,
        data: res.data.data,
        loading: false,
      })
      if (res.status === 201) {
        callback(true)
      }
    } catch (err) {
      dispatch({
        type: VIOLATION_REPORT,
        data: getState(),
        loading: false,
      })
      if ((err as AxiosError).response?.status === 201) {
        callback(false)
      }
    }
  }

export const fetchCancellationRules: MainAction<
  [
    'easy' | 'medium' | 'hard',
    string,
    Record<string, string | number | boolean | undefined>?,
  ]
> =
  (plan, houseId, params = {}) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    dispatch({
      type: GET_CANCELLATION_RULES,
      data: null,
      loading: true,
    })

    try {
      const res: AxiosResponse = await api.get(
        `/reserve/cancellation-rules/${plan}`,
        { ...params },
      )
      dispatch({
        type: GET_CANCELLATION_RULES,
        data: res?.data?.data,
        id: houseId,
        loading: false,
      })
    } catch (err) {
      dispatch({
        type: GET_CANCELLATION_RULES,
        data: getState()?.productReducer?.data?.cancellationRules?.data,
        loading: false,
      })
    }
  }
